export default function parseMentionsMessage(text) {
  const regex = /@?\[([^\]]+)\]\(([^)]+)\)/g;
  const ids: string[] = [];
  const plainText = text.replace(regex, (_, display, id) => {
    ids.push(id);
    return `@${display}`;
  });

  return {
    plainText,
    ids,
  };
}
